import Vue from 'vue';
import { SET_SHIFT_CURRENT_ACTION } from '../mutation-types';

// state
const localState = {
  currentAction: '',
  TOTAL_PAYTYPE: 400,
  AMOUNT_PAYTYPE: 700,
  CASH_PAYTYPE: 800,
  CHANGE_PAYTYPE: 1100,
};

// getters
const localGetters = {
  getOtherPayTypes: (state, getters) => (isCreditCard = false) => {
    const otherPayTypes = getters
      .getArray('payTypes')
      .filter(payType => payType.indexNumber > state.CASH_PAYTYPE
                                          && payType.indexNumber < state.CHANGE_PAYTYPE
                                          && !!payType.isCreditCard === isCreditCard);

    return otherPayTypes.map(payType => payType.id);
  },

  calAmount: () => (bills) => {
    const totalAmount = bills.reduce((sum, { amount }) => sum + amount, 0);
    return totalAmount;
  },

  calTotalPayType: (state, getters) => (bills) => {
    const payTypeTotal = getters.getArray('payTypes').find(({ indexNumber }) => indexNumber === state.TOTAL_PAYTYPE);
    const total = payTypeTotal ? getters.calByKey(bills, payTypeTotal.id) : 0;
    return total;
  },

  calOther: (state, getters) => (closedBills, isCreditCard = false) => {
    const payTypeIds = getters.getOtherPayTypes(isCreditCard);
    if (payTypeIds.length === 0) return 0;

    const otherAmount = closedBills.reduce((sum, { payDetails }) => {
      let amount = 0;
      payDetails.forEach((payDetail) => {
        if (payTypeIds.includes(payDetail.payType)) {
          amount += payDetail.total;
        }
      });
      return sum + amount;
    }, 0);

    return otherAmount;
  },

  calByKey: () => (closedBills, key) => {
    const keyAmount = closedBills.reduce((sum, { payDetails }) => {
      let amount = 0;
      const payDetail = payDetails.find(({ payType }) => payType === key);
      if (payDetail) {
        amount = payDetail.total;
      }
      return sum + amount;
    }, 0);

    return keyAmount;
  },

  getTaxCharges: (state, getters) => (closedBills) => {
    const taxChargePayTypes = getters.getArray('payTypes')
      .filter(payType => payType.indexNumber > state.TOTAL_PAYTYPE
                              && payType.indexNumber < state.AMOUNT_PAYTYPE)
      .sort((a, b) => (a.indexNumber > b.indexNumber ? 1 : -1));

    const taxCharges = [];

    taxChargePayTypes.forEach(({ id, name, value }) => {
      taxCharges.push({
        name,
        value,
        amount: getters.calByKey(closedBills, id).toFixed(2),
      });
    });

    return taxCharges;
  },
};

// mutations
const mutations = {
  [SET_SHIFT_CURRENT_ACTION](state, actionName) {
    state.currentAction = actionName;
  },
};

export default {
  state: localState,
  getters: localGetters,
  mutations,
};
